var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 4H21.5C20.1193 4 19 5.11929 19 6.5C19 7.88071 20.1193 9 21.5 9H41.5C43.1569 9 44.5 10.3431 44.5 12V42.75C44.5 44.2688 45.7312 45.5 47.25 45.5C48.7688 45.5 50 44.2688 50 42.75V7C50 5.34315 48.6569 4 47 4Z",
    fill: "#A5D5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8994 10C16.3628 10 16 10.4115 16 10.8133V48.5307C16 48.9325 16.3628 49.344 16.8994 49.344H42.9218C43.4584 49.344 43.8212 48.9325 43.8212 48.5307V10.8133C43.8212 10.4115 43.4584 10 42.9218 10H16.8994ZM14 10.8133C14 9.2205 15.3467 8 16.8994 8H42.9218C44.4745 8 45.8212 9.2205 45.8212 10.8133V48.5307C45.8212 50.1235 44.4745 51.344 42.9218 51.344H16.8994C15.3467 51.344 14 50.1235 14 48.5307V10.8133Z",
    fill: "#004A77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5469 26.5239H19.3682V24.5239H40.5469V26.5239Z",
    fill: "#004A77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5469 30.8081H19.3682V28.8081H40.5469V30.8081Z",
    fill: "#004A77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5469 45.6772H19.3682V43.6772H40.5469V45.6772Z",
    fill: "#004A77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5477 35.8853H31.9053V33.8853H40.5477V35.8853Z",
    fill: "#004A77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5477 40.4214H31.9053V38.4214H40.5477V40.4214Z",
    fill: "#004A77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34H19V40H29V34Z",
    fill: "#A5D5F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9875 13.2934C37.3777 13.6841 37.3773 14.3173 36.9865 14.7076L29.4666 22.2176C29.0762 22.6075 28.4437 22.6075 28.0533 22.2176L24.2934 18.4626C23.9026 18.0723 23.9022 17.4391 24.2924 17.0484C24.6827 16.6576 25.3159 16.6571 25.7066 17.0474L28.76 20.0967L35.5733 13.2924C35.964 12.9022 36.5972 12.9026 36.9875 13.2934Z",
    fill: "#004A77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.1f442052ea68699576b842e3727cde6a.svg";
export { ForwardRef as ReactComponent };